export default __webpack_public_path__ + "static/media/download-chart-icon.70478cc6.svg";